import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { Tree } from '../../../@types/vehicle-properties';
import { IconSearch } from '../../../styled-components/components/Icon';
import { SEARCH_TAB_ID } from './category';

interface ICategoriesTabProps {
  propertyTree: Tree;
  activeCategoryId: number;
  setCategory: (arg0: number) => void;
  modifiers?: string;
}

const CategoriesTabs = ({
  propertyTree,
  activeCategoryId,
  setCategory,
  modifiers,
}: ICategoriesTabProps) => {
  const { t } = useTranslation('item');
  const [translate, setTranslate] = useState(0);
  const [max, setMax] = useState(0);
  const listReference = useRef<HTMLUListElement>(null);
  const scrollDistance = 200;

  const onPrev = () =>
    setTranslate(0 < translate - scrollDistance ? translate - scrollDistance : 0);
  const onNext = () =>
    setTranslate(max < translate + scrollDistance ? max : translate + scrollDistance);

  useEffect(() => {
    if (listReference && listReference.current && listReference.current.children.length > 0) {
      // Add spacing between childrens into calculation
      let maxSize = 16 * (listReference.current.children.length - 1);

      // Add width for each children
      for (let i = 0; i < listReference.current.children.length; i++) {
        maxSize += listReference.current.children[i].clientWidth;
      }

      setMax(maxSize - listReference.current.clientWidth);
    }
  }, [listReference]);

  return (
    <div data-wx-tabs={modifiers ? modifiers : ''}>
      <div className="tabs">
        <ul
          className="tab-list"
          ref={listReference}
          style={{
            transform: `translateX(${-1 * translate}px)`,
            WebkitTransform: `translateX(${-1 * translate}px)`,
            msTransform: `translateX(${-1 * translate}px)`,
          }}
        >
          <li
            className={`tab-item separator-right${activeCategoryId === SEARCH_TAB_ID ? ' is-active' : ''}`}
          >
            <button
              type="button"
              onClick={() => setCategory(SEARCH_TAB_ID)}
              title={t('carDetailsSearch.tab.title', { ns: 'item' })}
              className="tab-action"
            >
              <IconSearch />
              {t('carDetailsSearch.tab.label', { ns: 'item' })}
            </button>
          </li>
          {propertyTree.categories.map((category, index) => {
            const isActive = category.id === activeCategoryId;
            const listClass = isActive ? 'tab-item is-active' : 'tab-item';

            return (
              <li key={`${category.name}-${index}`} className={listClass}>
                <button
                  type="button"
                  onClick={() => setCategory(category.id)}
                  title={t('Show car details in the category', { ns: 'item', name: category.name })}
                  className="tab-action"
                >
                  {category.name}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      {translate > 0 && (
        <div className="tabs-nav-prev">
          <button type="button" data-wx-actionbutton="" title="Föregående" onClick={onPrev}>
            <i className="icon-chevron-left no-margin" />
          </button>
        </div>
      )}
      {translate !== max && max > 0 && (
        <div className="tabs-nav-next">
          <button type="button" data-wx-actionbutton="" title="Nästa" onClick={onNext}>
            <i className="icon-chevron-right no-margin" />
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoriesTabs;
